export const LinearProgress = ({ progress }) => {
  return (
    <div className="w-full h-2 bg-gray-200">
      <div className="h-full bg-[#8052FF]" style={{ width: `${progress}%` }} />
    </div>
  )
}
